import { memo, useCallback } from 'react';

import { OrderCell } from 'modules/OverviewScene/components';
import { AppActions, AppSelectors } from 'store/App';
import { TabBarKey } from 'store/App/constants';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { OrderSelectors } from 'store/Orders';
import { Order } from 'store/Orders/types';
import { OrderCard } from 'components/OrderCard';

import type { ComponentProps } from 'react';

type NavItemProps = {
  order: Order;
  isScheduled?: boolean;
  tab: TabBarKey;
};

export const NavItem = memo((props: NavItemProps) => {
  const { order, isScheduled = false, tab } = props;

  const dispatch = useAppDispatch();
  const selectOrderUUID = useAppSelector(AppSelectors.selectOrderUUID);

  const items = useAppSelector((state) =>
    order
      ? OrderSelectors.selectItemsForOrderWithCategories(state, order.uuid)
      : null,
  )?.filter(
    (value): value is Exclude<typeof value, undefined> => value !== undefined,
  );

  const handlePress: ComponentProps<typeof OrderCell>['onPress'] = useCallback(
    (id: string) => {
      dispatch(AppActions.setSelectedOrderUUID({ orderUUID: id }));
    },
    [dispatch],
  );

  return (
    <OrderCard
      cardStyle={{
        minHeight: 100,
      }}
      order={order}
      items={items ?? []}
      isSelected={selectOrderUUID === order.uuid}
      onPress={(_, orderUuid) => {
        handlePress(orderUuid);
      }}
    />
  );
});

NavItem.displayName = 'NavItem';
